module.exports = __webpack_public_path__ + "img/5.1b98a4d1.jpg";